module.exports = __webpack_public_path__ + "static/media/dummy-profile-image.03cf9017.png";